type SocialMediaType = {
    url: string
    alt: string
    href: string
}

export const SocialMedia: Array<SocialMediaType> = [
    {
        url: 'assets/icons/social-media/linkedin.svg',
        alt: 'LinkedIn',
        href: 'https://www.linkedin.com/company/genomate-health/'
    },
    {
        url: 'assets/icons/social-media/twitter.svg',
        alt: 'Twitter',
        href: 'https://twitter.com/GenomateHealth'
    },
    {
        url: 'assets/icons/social-media/facebook.svg',
        alt: 'Facebook',
        href: 'https://www.facebook.com/genomate.health'
    },
    {
        url: 'assets/icons/social-media/instagram.svg',
        alt: 'Instagram',
        href: 'https://www.instagram.com/genomate.health/'
    }
]
